import React, { useState, useEffect } from 'react'
import Icon from 'components/Safra/Icon';

import Checkbox from "components/CheckboxCustom";
import ReserveDate from "components/Safra/SearchComponents/ReserveDate";
import Passengers from "components/Safra/SearchComponents/Passengers";
import SearchAirport from "components/Safra/SearchAirport"
import SwapButton from "components/Safra/SwapButton";
import { useTranslation } from "contexts/Safra/TranslationContext";
import {
    getOriginAirport,
    getDestinationAirport,
    swapAirports,
    decodeStorageValue
} from "utils/airportStorage";
import {
    SearchContainer,
    SearchContent,
    CheckboxRow,
    OriginDestinationWrapper,
    SwapButtonAnchor
} from "./styles";

export default function SearchAirfare() {
    const { t } = useTranslation();
    const [onlyIda, setOnlyIda] = useState(false)
    const [originValue, setOriginValue] = useState('');
    const [destinationValue, setDestinationValue] = useState('');

    useEffect(() => {
        const syncAirports = (e) => {
            const { tipo } = e?.detail || {};
            
            if (!tipo || tipo === 'origem') {
                const origin = getOriginAirport();
                if (origin?.name) {
                    setOriginValue(decodeStorageValue(origin?.name));
                }
            }
            
            if (!tipo || tipo === 'destino') {
                const destination = getDestinationAirport();
                if (destination?.name) {
                    setDestinationValue(decodeStorageValue(destination?.name));
                }
            }
        };

        window.addEventListener('safra-airport-change', syncAirports);

        return () => {
            window.removeEventListener('safra-airport-change', syncAirports);
        };
    }, [])

    const handleOnlyIda = (e) => {
        const checked = e.target.checked
        setOnlyIda(checked)

        try {
            localStorage.setItem('onlyDeparture', checked ? 'true' : 'false')
        }
        catch (err) {
            console.error('Error setting localStorage items for onlyDeparture:', err);
        }

        if (checked) {
            localStorage.setItem('to-date', '')
            localStorage.setItem('to_date', '')
            localStorage.setItem('to-date-formatted', '')

            const checkout = document.getElementById('passCheckout')
            if (checkout) checkout.value = ''
        }
    }

    const handleSwapAirports = () => {
        const origemInput = document.getElementById('passOrigem');
        const destinoInput = document.getElementById('passDestino');

        const origem = (origemInput?.value || originValue || '').trim();
        const destino = (destinoInput?.value || destinationValue || '').trim();

        if (!origem && !destino) {
            return;
        }

        swapAirports();

        setOriginValue(destino);
        setDestinationValue(origem);

        window.dispatchEvent(new CustomEvent('safra-airport-change'));

        setTimeout(() => {
            const ctaButton = document.getElementById('passage-search-cta');
            if (ctaButton?.focus) {
                ctaButton.focus();
            }
        }, 0);
    };

    return (
        <SearchContainer>
            <SearchContent>
                <OriginDestinationWrapper>
                    <SearchAirport
                        placeholder='Cidade ou aeroporto'
                        tipo='origem'
                        id='passOrigem'
                        groupPosition='top'
                        defaultValue={originValue}
                    />

                    <SearchAirport
                        placeholder='Cidade ou aeroporto'
                        tipo='destino'
                        id='passDestino'
                        groupPosition='bottom'
                        defaultValue={destinationValue}
                    />
                    <SwapButtonAnchor>
                        <SwapButton onClick={handleSwapAirports} />
                    </SwapButtonAnchor>
                </OriginDestinationWrapper>

                <CheckboxRow>
                    <Checkbox id='chkIda' checked={onlyIda} onChange={handleOnlyIda} />
                    <label className="label" htmlFor="chkIda" style={{ cursor: 'pointer' }}>{t('safra.components.search_bar.only_one_way')}</label>
                </CheckboxRow>

                <ReserveDate
                    iconStart={<Icon name="calendar" size={20} />}
                    iconEnd={<Icon name="calendar" size={20} />}
                    placeholderStart={t('safra.home.fields.departure')}
                    placeholderEnd={t('safra.home.fields.return')}
                    page="airfare"
                    onlyIda={onlyIda}
                    travel={true}
                    boxed={true}
                />

                <Passengers boxed={true} />
            </SearchContent>
        </SearchContainer>
    )
}
